import { createMutation } from '@tanstack/svelte-query';
import { createInputAction, updateInputAction, deleteInputAction } from '$lib/api/input_action';
import { invalidateAfterInputDeviceUpdate } from '$lib/state/invalidation';
import { getUnitScope, resolveScope, type ScopeFn } from '$lib/queries/scope';
import type { InputActionRequest, InputActionResponse } from '$lib/types/input_action';

export const createInputActionMutation = (scope: ScopeFn = getUnitScope()) =>
  createMutation<InputActionResponse, Error, InputActionRequest>(() => ({
    mutationFn: (request) => createInputAction(request),
    onSuccess: () => invalidateAfterInputDeviceUpdate(resolveScope(scope))
  }));

export const updateInputActionMutation = (scope: ScopeFn = getUnitScope()) =>
  createMutation<InputActionResponse, Error, { id: number; data: Partial<InputActionRequest> }>(
    () => ({
      mutationFn: ({ id, data }) => updateInputAction(id, data),
      onSuccess: () => invalidateAfterInputDeviceUpdate(resolveScope(scope))
    })
  );

export const deleteInputActionMutation = (scope: ScopeFn = getUnitScope()) =>
  createMutation<void, Error, number>(() => ({
    mutationFn: (id) => deleteInputAction(id),
    onSuccess: () => invalidateAfterInputDeviceUpdate(resolveScope(scope))
  }));
